import React, {Component} from "react";
import TopNav from "../common/nav/TopNav";
import Footer from "../common/Footer";
import PageBlock from "../common/PageBlock";
import CoreService from "../service/CoreService";
import BotStatusService from "../service/BotStatusService";
import BotStatusPanel from "../common/BotStatusPanel";
import LastBuildStatusPanel from "../common/LastBuildStatusPanel";
import MocksStatusService from "../service/MocksStatusService";
import MocksStatusPanel from "../common/MocksStatusPanel";
import SiteService from "../service/SiteService";
import {defaultTenantId} from "../service/TenantService";

class Dashboard extends Component {
    constructor() {
        super();

        this.state = {
            mock: {
                status: 'LOADING'
            },
            bot: {
                status: 'LOADING'
            },
            lastBuild: {
                outcome: 'LOADING'
            }
        }
    }

    componentDidMount() {
        const self = this;

        if (SiteService.isMocksSite()) {
            MocksStatusService.fetchMocksStatus(defaultTenantId, (mocksStatus) => {
                if (mocksStatus) {
                    self.setState({mock: mocksStatus})
                } else {
                    CoreService.showPassiveError("Sorry, we can't fetch the status of your mocks right now.");
                }
            });
        } else {
            BotStatusService.fetchBotStatus((botStatus) => {
                if (botStatus) {
                    self.setState({bot: botStatus})
                } else {
                    CoreService.showPassiveError("Sorry, we can't fetch the status of your bot right now.");
                }
            });
            BotStatusService.fetchLastBuildOutcome((lastBuildStatus) => {
                if (lastBuildStatus) {
                    self.setState({lastBuild: lastBuildStatus})
                } else {
                    CoreService.showPassiveError("Sorry, we can't fetch the status of your last build right now.");
                }
            });
        }
    }

    render() {
        return (
            <div>
                <TopNav tab="dashboard"/>

                <PageBlock small={true}>
                    <div className="container">
                        <div className="row m-t-lg">
                            {SiteService.isMocksSite() &&
                            <MocksStatusPanel status={this.state.mock}/>}

                            {SiteService.isBotSite() &&
                            <BotStatusPanel status={this.state.bot}/>}

                            {SiteService.isBotSite() &&
                            <LastBuildStatusPanel status={this.state.lastBuild}/>}
                        </div>
                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/modules/views/Dashboard.js